import Model     from "../core/Model";

export default class Currency extends Model
{
    constructor( options = {} )
    {
        super(null);

        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        this.code    = options.code   || 'EUR';
        this.value   = options.value  || 0;
        this.rate    = options.rate   || 1;
    }

    toJson()
    {
        return {
            code    : this.code,
            value   : this.unit,
            rate    : this.rate,
        }
    }

    getLabel()
    {
        return printf('%s%s', this.value.toLocaleString(window.lang), Currency.symbol(this.code));
    }

    label()
    {
        return this.getLabel();
    }

    static symbol(code){

        switch(code){

            case 'EUR' : return '€';
            case 'USD' : return '$';
        }

        return '';
    }

}


// WEBPACK FOOTER //
// ./resources/js/models/Currency.js